import React from 'react';
import { Flex, Box } from '@chakra-ui/react';

export const MockupGames = () => {
    return (
        <Flex gridGap='12px' alignItems='center'>
            <Box w='61px' h='80px' borderRadius='2px' bgColor='#2D2D2D'/>
            <Box w='61px' h='80px'  borderRadius='2px' bgColor='#2D2D2D'/>
            <Box w='61px' h='80px'  borderRadius='2px' bgColor='#2D2D2D'/>
        </Flex>
    );
};

export default MockupGames;
